import { ApiService } from './ApiService'

export type OAuthConsentRequest = {
  clientName: string
  /** Declared by the client at registration; https only, and may be absent. */
  logoUri: string | null
  clientUri: string | null
  redirectUri: string
  /** Host the code is delivered to — the one claim the client cannot fake. */
  redirectOrigin: string
  scope: string
}

/**
 * The consent step of the API's OAuth server.
 *
 * The browser arrives here holding nothing but an opaque `request_id` — the
 * actual authorization parameters stay on the API, so this app never has to
 * understand OAuth, and nothing in the URL is worth tampering with.
 */
export class OAuthService extends ApiService {
  static CONSENT_PATH = '/oauth/authorize/:requestId'

  static async getConsentRequest(
    requestId: string
  ): Promise<OAuthConsentRequest> {
    const response = await ApiService.get(
      OAuthService.CONSENT_PATH.replace(':requestId', requestId)
    )

    return response.data
  }

  /** Returns the URL to send the browser to, approved or not. */
  static async resolveConsent(
    requestId: string,
    approved: boolean
  ): Promise<string> {
    const response = await ApiService.post(
      OAuthService.CONSENT_PATH.replace(':requestId', requestId),
      { approved }
    )

    return response.data.redirectTo
  }
}
